import styled from "styled-components";
import {
  RelayAccess,
  TenantEmail,
  TenantLogo,
  TenantName,
  TenantSlug,
} from "./components";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  overflow-y: auto;
  padding-right: 20px;
  margin: 0 auto;

  max-width: 800px;

  .relay-link {
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    margin: 10px 0px;
    &:hover {
      text-decoration: underline;
    }
  }

  .message {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-weight: 400;
    font-size: 14px;
  }
`;

export const BasicDetails: React.FC = () => {
  return (
    <StyledContent>
      <RelayAccess />
      <TenantLogo />
      <TenantName />
      <TenantEmail />
      <TenantSlug />
    </StyledContent>
  );
};
